exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".-page-size-select{display:inline-block;width:65px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-e36dd9ec!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue2-datatable-component/src/PageSizeSelect.vue
// module id = 937
// module chunks = 2